/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateCalendarEventModal_companyCalendarEvent$ref: FragmentReference;
declare export opaque type AddUpdateCalendarEventModal_companyCalendarEvent$fragmentType: AddUpdateCalendarEventModal_companyCalendarEvent$ref;
export type AddUpdateCalendarEventModal_companyCalendarEvent = {|
  +id: string,
  +name: string,
  +isFullDay: boolean,
  +isOpen: boolean,
  +startAt: any,
  +endAt: any,
  +$refType: AddUpdateCalendarEventModal_companyCalendarEvent$ref,
|};
export type AddUpdateCalendarEventModal_companyCalendarEvent$data = AddUpdateCalendarEventModal_companyCalendarEvent;
export type AddUpdateCalendarEventModal_companyCalendarEvent$key = {
  +$data?: AddUpdateCalendarEventModal_companyCalendarEvent$data,
  +$fragmentRefs: AddUpdateCalendarEventModal_companyCalendarEvent$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "AddUpdateCalendarEventModal_companyCalendarEvent",
  "type": "CompanyCalendarEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFullDay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isOpen",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endAt",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '17748ab6a48f3dd72b7f51e5f7fc63e1';
module.exports = node;
